<template>
  <zone-selection :name-route="nameRoute"/>
</template>

<script>
import zoneSelection from '../../../components/zone-selection/zone-selection'
export default {
  name: 'ZoneSelectionView',
  components: {
    zoneSelection
  },
  data () {
    return {
      nameRoute: ''
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.nameRoute = from.name
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/zone-selection/zone-selection.view.vue